// Wishlist functionality
class Wishlist {
  constructor() {
    this.storageKey = 'shopify_wishlist';
    this.init();
  }

  init() {
    this.updateHeaderCount();
    this.bindEvents();
    
    // If on wishlist page, load items
    if (window.location.pathname.includes('/pages/wishlist')) {
      this.loadWishlistPage();
    }
  }

  getWishlist() {
    const wishlist = localStorage.getItem(this.storageKey);
    return wishlist ? JSON.parse(wishlist) : [];
  }

  saveWishlist(wishlist) {
    localStorage.setItem(this.storageKey, JSON.stringify(wishlist));
    this.updateHeaderCount();
  }

  addToWishlist(productData) {
    let wishlist = this.getWishlist();
    
    // Check if already exists
    const exists = wishlist.find(item => item.handle === productData.handle);
    if (!exists) {
      wishlist.push(productData);
      this.saveWishlist(wishlist);
      return true;
    }
    return false;
  }

  removeFromWishlist(handle) {
    let wishlist = this.getWishlist();
    wishlist = wishlist.filter(item => item.handle !== handle);
    this.saveWishlist(wishlist);
  }

  isInWishlist(handle) {
    const wishlist = this.getWishlist();
    return wishlist.some(item => item.handle === handle);
  }

  updateHeaderCount() {
    const count = this.getWishlist().length;
    const countElements = document.querySelectorAll('[data-wishlist-count]');
    countElements.forEach(el => {
      el.textContent = count;
      if (count === 0) {
        el.style.display = 'none';
      } else {
        el.style.display = 'flex';
      }
    });
  }

  bindEvents() {
    // Wishlist button clicks
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('.wishlist-btn');
      if (btn) {
        e.preventDefault();
        e.stopPropagation();
        this.toggleWishlist(btn);
      }

      // Remove from wishlist
      const removeBtn = e.target.closest('.wishlist-remove-btn');
      if (removeBtn) {
        const handle = removeBtn.dataset.handle;
        this.removeFromWishlist(handle);
        this.loadWishlistPage();
      }

      // Clear all
      const clearBtn = e.target.closest('#clear-wishlist');
      if (clearBtn) {
        if (confirm('Are you sure you want to clear your wishlist?')) {
          localStorage.removeItem(this.storageKey);
          this.loadWishlistPage();
          this.updateHeaderCount();
        }
      }
    });

    // Update wishlist buttons on page load
    this.updateWishlistButtons();
  }

  toggleWishlist(btn) {
    const handle = btn.dataset.productHandle;
    const productId = btn.dataset.productId;

    if (this.isInWishlist(handle)) {
      this.removeFromWishlist(handle);
      btn.classList.remove('active');
    } else {
      // Fetch product data
      fetch(`/products/${handle}.js`)
        .then(response => response.json())
        .then(product => {
          const productData = {
            id: product.id,
            handle: product.handle,
            title: product.title,
            price: product.price,
            image: product.featured_image,
            url: `/products/${product.handle}`
          };
          this.addToWishlist(productData);
          btn.classList.add('active');
        });
    }
  }

  updateWishlistButtons() {
    const buttons = document.querySelectorAll('.wishlist-btn');
    buttons.forEach(btn => {
      const handle = btn.dataset.productHandle;
      if (this.isInWishlist(handle)) {
        btn.classList.add('active');
      }
    });
  }

  loadWishlistPage() {
    const wishlist = this.getWishlist();
    const emptyDiv = document.getElementById('wishlist-empty');
    const gridDiv = document.getElementById('wishlist-grid');
    const clearBtn = document.getElementById('clear-wishlist');

    if (!gridDiv) return;

    if (wishlist.length === 0) {
      emptyDiv.style.display = 'block';
      gridDiv.style.display = 'none';
      if (clearBtn) clearBtn.style.display = 'none';
    } else {
      emptyDiv.style.display = 'none';
      gridDiv.style.display = 'grid';
      if (clearBtn) clearBtn.style.display = 'block';

      gridDiv.innerHTML = wishlist.map(item => `
        <div class="wishlist-item">
          <button class="wishlist-remove-btn" data-handle="${item.handle}">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
          <a href="${item.url}">
            <img src="${item.image}" alt="${item.title}" class="wishlist-item-image">
            <h3 class="wishlist-item-title">${item.title}</h3>
            <div class="wishlist-item-price">${this.formatMoney(item.price)}</div>
          </a>
        </div>
      `).join('');
    }
  }

  formatMoney(cents) {
    return 'Rs ' + (cents / 100);
  }
}

// Initialize wishlist
document.addEventListener('DOMContentLoaded', () => {
  window.wishlistApp = new Wishlist();
});